/* Handles search behavior for the search modal */

import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import aa from 'search-insights';
import { searchBox, hits, configure, stats, index } from 'instantsearch.js/es/widgets';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import Cookies from 'cookies-js';

aa('init', { appId: algoliaConfig.id, apiKey: algoliaConfig.key, useCookie: true });
let userToken = window.algoliaUserToken ? window.algoliaUserToken : Cookies.get('_ALGOLIA');
aa('setUserToken', userToken);

const insightsMiddleware = createInsightsMiddleware({
	insightsClient: aa
});

// don't search empty requests
// basically, we pass the request through a proxy client so we can detect empty-ness
// https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/js/#detecting-empty-search-requests
const algoliaClient = algoliasearch(
	window.algoliaConfig.id,
	window.algoliaConfig.key
);
const initalEl = document.getElementById('search-not-performed');
const hitsEl = document.getElementById('search-performed');
const searchClient = {
	...algoliaClient,
	search(requests) {
		if (requests.every(({ params }) => !params.query)) {
			initalEl.style.display = "block";
			hitsEl.style.display = "none";
			return Promise.resolve({
				results: requests.map(() => ({
					hits: [],
					nbHits: 0,
					nbPages: 0,
					page: 0,
					processingTimeMS: 0,
				})),
			});
		} else {
			initalEl.style.display = "none";
			hitsEl.style.display = "block";
		}
		return algoliaClient.search(requests);
	},
};

function headerOutput(data, label, type) {
	let count;
	let link = '';
	if (data.hasManyResults) {
		count = `${data.nbHits} ${label} matches`;
		if (data.nbHits > 6) {
			link = `<a href="${window.algoliaShop}/search?q=${data.query}#ais-${type}-stats" class="btn forward">All results <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><use href="#icon-arrow" /></svg></a>`
		}
	} else if (data.hasOneResult) {
		count = `1 ${label} match`;
	} else {
		count = `0 ${label} matches`;
	}
	return `<h2>${count}</h2>${link}`;
}

const search = instantsearch({
	indexName: window.algoliaConfig.indices.products,
	searchClient
});
search.use(insightsMiddleware);

search.addWidgets([
	configure({
		clickAnalytics: true,
		hitsPerPage: 10
	}),
	searchBox({
		container: '#aac',
		showSubmit: false,
		showReset: false,
		showLoadingIndicator: false,
		placeholder: 'Search'
	}),
	index({ indexName: window.algoliaConfig.indices.holsters }).addWidgets([
		configure({
			facetFilters: [
				'online_flag:1'
			]
		}),
		hits({
			container: '#aac-h-hits',
			templates: {
				empty(results) {
					let q = results.query ? `for <q>${results.query}</q>` : '';
					return `No holster results ${q}`;
				},
				item(hit, bindEvent) {
					let _state = search.renderState[window.algoliaConfig.indices.products].searchBox; // using the products index since that's what's used in instantsearch({}) above when defining search
					var img = '';
					if (hit.thumbnail) {
						var thumbnail = hit.thumbnail.replace('.jpg', '_283x250.jpg');
						img = `<img src="${thumbnail}" alt="">`;
					}
					// default price
					var price = hit.price;
					var priceHtml = '$' + window.helpers.numberWithCommas(price.toFixed(2));
					// parent products will have a 0 price
					if (!price) {
						// price_min might be 0 when a price isn't set on one of the children
						price = parseFloat(hit.price_max);
						// support price ranges making sure we have a non-zero min price
						if (parseFloat(hit.price_min) > 0 && hit.price_min !== hit.price_max) {
							priceHtml = '$' + window.helpers.numberWithCommas(parseFloat(hit.price_min).toFixed(2)) + ' &mdash; ' + '$' + window.helpers.numberWithCommas(parseFloat(hit.price_max).toFixed(2));
						} else {
							priceHtml = '$' + window.helpers.numberWithCommas(price.toFixed(2));
						}
					}
					var url = window.helpers.algoliaHitUrl(hit, _state, window.algoliaConfig.indices.holsters);
					return `<a class="product-item" href="${url}" ${bindEvent('click', hit, 'Search Result Clicked')}>
              <div class="thumbnail">${img}</div>
              <div class="title">${instantsearch.highlight({ attribute: 'name', hit })}</div>
              <div class="price">${priceHtml}</div>
            </a>`;
				}
			},
		}),
		stats({
			container: '#aac-h-stats',
			templates: {
				text(data) {
					return headerOutput(data, 'Holster', 'h');
				},
			}
		}),
		stats({
			container: '#aac-h-count',
			templates: {
				text(data) {
					return `(${data.nbHits})`
				},
			}
		})
	]),
	index({ indexName: window.algoliaConfig.indices.products }).addWidgets([
		configure({
			facetFilters: 'product_type:-Holsters',
		}),
		hits({
			container: '#aac-p-hits',
			templates: {
				empty(results) {
					let q = results.query ? `for <q>${results.query}</q>` : '';
					return `No product results ${q}`;
				},
				item(hit, bindEvent) {
					let _state = search.renderState[window.algoliaConfig.indices.products].searchBox;
					var img = '';
					if (hit.image) {
						var src = hit.image.replace('.jpg', '_283x250.jpg');
						img = `<img src="${src}" alt="">`;
					}
					var price = window.helpers.numberWithCommas(hit.price.toFixed(2));
					var priceHtml = '$' + price;
					if (hit.variants_min_price !== hit.variants_max_price) {
						priceHtml = '$' + window.helpers.numberWithCommas(hit.variants_min_price.toFixed(2)) + ' &mdash; ' + '$' + window.helpers.numberWithCommas(hit.variants_max_price.toFixed(2));
					}
					// find a dealer products
					if (hit.price === 9999.99) {
						priceHtml = '';
					}
					var url = window.helpers.algoliaHitUrl(hit, _state, window.algoliaConfig.indices.products);
					return `<a class="product-item" href="${url}" ${bindEvent('click', hit, 'Search Result Clicked')}>
              <div class="thumbnail">${img}</div>
              <div class="title">${instantsearch.highlight({ attribute: 'title', hit })}</div>
              <div class="price">${priceHtml}</div>
            </a>`;
				}
			},
		}),
		stats({
			container: '#aac-p-stats',
			templates: {
				text(data) {
					return headerOutput(data, 'Equipment', 'p');
				},
			}
		}),
		stats({
			container: '#aac-p-count',
			templates: {
				text(data) {
					return `(${data.nbHits})`
				},
			}
		})
	]),
	index({ indexName: window.algoliaConfig.indices.articles }).addWidgets([
		configure({
			hitsPerPage: 6
		}),
		hits({
			container: '#aac-a-hits',
			templates: {
				empty(results) {
					let q = results.query ? `for <q>${results.query}</q>` : '';
					return `No article results ${q}`;
				},
				item(hit, bindEvent) {
					return `<a class="article-result" href="${hit.permalink}" ${bindEvent('click', hit, 'Search Result Clicked')}>${instantsearch.highlight({ attribute: 'post_title', hit })}</a>`;
				}
			},
		}),
		stats({
			container: '#aac-a-stats',
			templates: {
				text(data) {
					return headerOutput(data, 'Education', 'a');
				},
			}
		})
	]),
	index({ indexName: window.algoliaConfig.indices.pages }).addWidgets([
		configure({
			hitsPerPage: 6
		}),
		hits({
			container: '#aac-pg-hits',
			templates: {
				empty(results) {
					let q = results.query ? `for <q>${results.query}</q>` : '';
					return `No page results ${q}`;
				},
				item(hit, bindEvent) {
					return `<a class="article-result" href="/pages/${hit.handle}" ${bindEvent('click', hit, 'Search Result Clicked')}>${instantsearch.highlight({ attribute: 'title', hit })}</a>`;
				}
			},
		}),
		stats({
			container: '#aac-pg-stats',
			templates: {
				text(data) {
					return headerOutput(data, 'Page', 'pg');
				},
			}
		})
	]),
	index({ indexName: window.algoliaConfig.indices.saves }).addWidgets([
		configure({
			hitsPerPage: 6
		}),
		hits({
			container: '#aac-s-hits',
			templates: {
				empty(results) {
					let q = results.query ? `for <q>${results.query}</q>` : '';
					return `No Saves Club results ${q}`;
				},
				item(hit, bindEvent) {
					return `<a class="article-result" href="${hit.permalink}" ${bindEvent('click', hit, 'Search Result Clicked')}>${instantsearch.highlight({ attribute: 'post_title', hit })}</a>`;
				}
			},
		}),
		stats({
			container: '#aac-s-stats',
			templates: {
				text(data) {
					return headerOutput(data, 'Saves Club', 's');
				},
			}
		})
	])
]);

search.on('render', () => {
	let $searchModal = $('#search-modal');

	// Sort tabs by number of results
	let $nav = $searchModal.find('#search-grid-primary .tabs .nav');
	$nav.find('li').sort(function (a, b) {
		let aCount = $(a).find('.ais-Stats-text').text().replace(/\D/g, '');
		let bCount = $(b).find('.ais-Stats-text').text().replace(/\D/g, '');
		return bCount - aCount;
	})
	.appendTo($nav);
	$nav.find('li .nav-item').first().trigger('click');

	// Hide empty sidebar tabs
	$searchModal.find('#search-grid-secondary .section').each(function () {
		$(this).show();
		if ($(this).find('.ais-Stats-text').text().replace(/\D/g, '') === '0') {
			$(this).hide();
		}
	});
});

search.start();

$b.on('click', '#search-modal .nav-item', function (e) {
	e.preventDefault();
	$('#search-modal .nav li').removeClass('active');
	$('#search-modal .tab-content').removeClass('active');
	$(this).closest('li').addClass('active');
	$($(this).data('target')).addClass('active');
	$('#active-tab-label').html($(this).html());
	$('.dropdown').removeClass('is-open');
});

$b.on('keyup', function (e) {
	if (e.code === 'Enter') {
		if ($('#search-modal').hasClass('shown')) {
			window.location.href = window.location.origin + '/search?q=' + encodeURIComponent($('.ais-SearchBox-input').val());
		}
	}
});

$('#aac-h-hits').bind('DOMSubtreeModified', function () {
	let $emptyContainer = $(this).find('.ais-Hits--empty');
	let $navButtons = $('#search-tabs nav button');
	if ($emptyContainer.length) {
		$emptyContainer.append($navButtons);
	}
});


$('#add-to-cart').on('click', function(e){
	let data = sessionStorage.getItem('aa-' + window.productHandle); // get set in product.js when we land on a PDP from a search
	if (data) {
		let obj = JSON.parse(data);
		aa('convertedObjectIDsAfterSearch', {
			index: obj.index,
			eventName: 'Add To Cart',
			queryID: obj.query,
			objectIDs:  [obj.object]
		});
		sessionStorage.removeItem('aa-' + window.productHandle); // only attribute this conversion once
	}
});